import { Component, Inject, Optional, OnInit, ViewChild, ElementRef } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import {TranslateService} from '@ngx-translate/core';
import { TipoOperacion } from 'app/main/models/tipo-operacion.model';
import {Observable} from 'rxjs';
import { Pais } from 'app/main/models/pais.model';
import { PaisService } from 'app/main/services/pais.service';
import { FormControl } from '@angular/forms';
import { map, startWith } from 'rxjs/operators';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';

@Component({
  selector: 'tipo-sujeto-obligado-dialog-box',
  templateUrl: './dialog-box.component.html',
  styleUrls: ['./dialog-box.component.scss']
})
export class TipoDocumentoDialogBoxComponent {

  action: string;
  LOCAL_DATA: any;

  tipos_documento = [{"nombre":"Persona física", "value":"PERSONA_FISICA"},
                     {"nombre":"Persona jurídica", "value":"PERSONA_JURIDICA"}];
  roles = [];
  empresas = [];
  paises = [];
  filteredPaises: Observable<Pais[]>;
  tipoCtrl = new FormControl();
  @ViewChild('tipoInput') tipoInput: ElementRef<HTMLInputElement>;


  constructor(
    public dialogRef: MatDialogRef<TipoDocumentoDialogBoxComponent>,
    public translate: TranslateService,
    public service: PaisService,
    // @Optional() is used to prevent error if no data is passed
    @Optional() @Inject(MAT_DIALOG_DATA) public data: TipoOperacion) {
    console.log(data);
    this.LOCAL_DATA = {...data};
    this.action = this.LOCAL_DATA.action;
  }

  ngOnInit(): void {

    this.service.getList().pipe().subscribe(req => {
      this.paises = req.body.map( tipo => {
        console.log(tipo);
        return {
          id: tipo.id,
          nombre: tipo.nombre
        };
      });

      this.filteredPaises = this.tipoCtrl.valueChanges.pipe(
        startWith(null),
        map((tipo: Pais | null) => tipo ? this._filter(tipo) : this.paises.slice()));
    });
  }

  selected(event: MatAutocompleteSelectedEvent): void {
    if(this.LOCAL_DATA.tipoEvaluacion == undefined){
      this.LOCAL_DATA.tipoEvaluacion = [];
    }
    this.LOCAL_DATA.tipoEvaluacion.push(event.option.value);
    this.tipoInput.nativeElement.value = '';
    this.tipoCtrl.setValue(null);
  }

  private _filter(value: Pais): Pais[] {
    const filterValue = value.nombre.toLowerCase();
    return this.paises.filter(tipo => value.nombre.toLowerCase().indexOf(filterValue) === 0);
  }

  doAction(): void{
    console.log('im here');
    this.dialogRef.close({event: this.action, data: this.LOCAL_DATA});
  }

  closeDialog(): void{
    this.dialogRef.close({event: 'Cancel'});
  }

  compareObjects(o1: any, o2: any): boolean {
    var equals = false;
    if(o1!=null && o2!=null && typeof o1 === 'object' &&  typeof o2 === 'object' && 'id' in o1 && 'id' in o2 && o1.id === o2.id){
      equals = true;
    }else{
      equals = (o1 == o2)? true:false;
    }

    return equals;
  }


}
